import classes from './SmartWarehouse.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import {Link} from "react-scroll";
import eRoadImg from '../../../media/projects/e-road.webp'
import Solutions from "../../../components/solutions/Solutions.tsx";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';


const SmartWarehouse = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
            
    const title = t('smartWarehouse.title')
    const description = t('smartWarehouse.text', {returnObjects: true})

    const solutionsBlocks= t('smartWarehouse.solutionsBlocks', {returnObjects: true})
    
    const blackBlocks = t('smartWarehouse.blackBlocks', {returnObjects: true})

    const benefitBlocks= t('smartWarehouse.benefitBlocks', {returnObjects: true})





    const questions: { left: IQuestion[]; right: IQuestion[] } = {
        left: t('smartWarehouse.Faq.left', {returnObjects: true}),
        right: t('smartWarehouse.Faq.right', {returnObjects: true}),
    };


    return (
        <>
            <Helmet>
                <title>
                    Warehouse Management System (WMS) for Efficient Inventory Control | Goteco
                </title>
                <meta
                    name="description"
                    content="Optimize your logistics with Goteco’s Warehouse Management System. Track inventory in real-time, automate warehouse operations, and reduce fulfillment costs."
                />
                <link rel="canonical" href="https://go-te.co/solutions/smart-warehouse-management" />
            </Helmet>
            <main>
            <Heading title={title} description={description} maxWidth={800}/>

            <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('smartWarehouse.solutionsBlocksTitle')}</h2>
                </div>

                <div>
                    {solutionsBlocks.map(({image, title, text}) => <div key={title} className={classes.block}>
                        <img alt={title} src={require(`./media/${image}`)}/>
                        <div className={classes.content}>
                            <h5>{title}</h5>
                            <p>{text}</p>
                        </div>
                    </div>)}
                </div>
            </section>

            <section className={`section--dark-gray ${classes['capabilities']}`} id={"nav-light"}>
                <h2>{t('smartWarehouse.blackBlocksTitle')}</h2>
                <div className={classes.blocks}>
                    {blackBlocks.map(({text, icon}) => (<BlackCardWithIcon key={icon} iconName={icon} text={text}/>))}
                </div>
            </section>

            <section className={`section--white ${classes['benefits']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('smartWarehouse.benefitBlocksTitle')}</h2>
                </div>
                <div>
                    {benefitBlocks.map(({title, text}) => <BlueGradientBlock title={title} text={text} key={title}/>)}
                </div>
            </section>

            <section className="section--light-gray" id="nav-dark">
                <FrequentlyAskedQuestions title={t('smartWarehouse.Faq.title')} questions={questions}/>
            </section>

            <section className={`section--white ${classes.industries}`}>
                <Solutions/>
            </section>

            <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                <div className={classes.content}>
                    <div className={classes['text-block']}>
                        <h2>{t('smartWarehouse.useCase')}</h2>
                        <div className={classes.text}>
                            <img alt="" src={eRoadImg}/>
                            <p>{t('smartWarehouse.useCaseSubtitle')}</p>
                        </div>
                    </div>
                    <div className={classes.actions}>
                        <span>{t('smartWarehouse.useCaseText')}</span>
                        <Link className={classes.link} smooth={true} to={'contact'}>{t('smartWarehouse.useCaseButton')}</Link>
                    </div>
                </div>
                <img alt="" className={classes.img} src={eRoadImg}/>
            </section>

            <section className="section--white" id="nav-dark">
                <FormCard 
                        title={t('smartWarehouse.formCard.title')}
                        subtitle={t('smartWarehouse.formCard.subtitle')}
                        message={t('smartWarehouse.formCard.message')}
                        buttonText={t('smartWarehouse.formCard.buttonText')}
                        labels={t('smartWarehouse.formCard.labels', {returnObjects: true})}
                        top={3} id='contact'/>
            </section>

        </main>
        </>
    );
};

export default SmartWarehouse;
